export const SORT_BY_FIRST_NAME = 'sort_by_first_name';
export const SORT_BY_LAST_NAME = 'sort_by_last_name';
export const SORT_BY_START_TIME = 'sort_by_start_time'; // Not implemented
export const DEFAULT_SORT = SORT_BY_FIRST_NAME;

export type EmployeeSortableType = typeof SORT_BY_FIRST_NAME | typeof SORT_BY_LAST_NAME | typeof SORT_BY_START_TIME;
